import React from 'react';
import {Form, Input} from 'semantic-ui-react';

const FormClientWaitHappy = ({detail}) => {
  const {name, email, phone, customerId} = detail;

  return (
    <React.Fragment>
      <Form.Group widths='three'>
        <Form.Field
          control={Input}
          label='Nombre'
          value={name}
          placeholder='Nombre'
        />
        <Form.Field
          control={Input}
          label='Cédula'
          value={customerId}
          placeholder='Cédula'
        />
        <Form.Field
          control={Input}
          label='Email'
          value={email}
          placeholder='Email'
        />
      </Form.Group>
      <Form.Group widths='three'>
        <Form.Field
          control={Input}
          label='Teléfono'
          value={phone}
          placeholder='Telefono'
        />
      </Form.Group>
    </React.Fragment>
  );
};

export default FormClientWaitHappy;
